import { Typography } from "@mui/material";
import React from "react";

export function oneProfileHeading() {
  return (
    <Typography variant={"h1"} color={"primary.dark"}>
      OneProfile
      <Typography variant={"caption"} color={"secondary"} sx={{ p: 1 }}>
        BETA
      </Typography>
    </Typography>
  );
}
